import React, { createContext, useContext, useMemo } from 'react';
import PropTypes from 'prop-types';

const HolidayListContext = createContext();

// Sample holiday data
   const holidays = [
    { date: "Jan 01", name: "New Year's Day" },
    { date: "Jan 14", name: "Makar Sankranti/Pongal" },
    { date: "Jan 26", name: "Republic Day" },
    { date: "Mar 04", name: "Holi" },
    { date: "Mar 26", name: "Ram Navami" },
    { date: "Apr 03", name: "Good Friday" },
    { date: "May 27", name: "Eid al-Adha / Bakrid" },
    { date: "Jun 02", name: "Telangana Formation Day" },
    { date: "Aug 15", name: "Independence Day" },
    { date: "Aug 26", name: "Onam" },
    { date: "Aug 28", name: "Raksha Bandhan" },
    { date: "Sep 04", name: "Janmashtami" },
    { date: "Sep 14", name: "Ganesh Chaturthi" },
    { date: "Oct 02", name: "Gandhi Jayanti" },
    { date: "Oct 19", name: "Durga Ashtami" },
    { date: "Oct 20", name: "Dussehra" },
    { date: "Nov 08", name: "Diwali" },
    { date: "Dec 25", name: "Christmas Day" }
  ];

export const HolidayListContextProvider = ({children}) => {
    const holidayList = useMemo(()=> holidays, []) // to ensure that holidayData is only created once and reused
    return(
        <HolidayListContext.Provider value={holidayList}>
         {children}
        </HolidayListContext.Provider>
    )
};

HolidayListContextProvider.propTypes = {
    children: PropTypes.node.isRequired
};

export const useHolidayListContext = () => {
    return useContext(HolidayListContext);
}